























































import { defineComponent, ref } from '@nuxtjs/composition-api'
import LangSwitch from '@app/components/common/LangSwitch.vue'
export default defineComponent({
  components: {
    LangSwitch,
  },
  props: {
    showBeta: {
      type: Boolean,
      default: false,
    },
  },
})
